export const baseAutoCompleteConfig = (searchId) => ({
    events: {
        input: {
            results: () => {
                const dropdown = document.querySelector(`#dropdown-${searchId}`);
                if (dropdown) {
                    dropdown.style.display = "block";
                }
            }
        }
    },
    threshold: 2,
    debounce: 300,
    resultsList: {
        render: true,
        container: source => {
            source.setAttribute("id", `dropdown-${searchId}`);
            source.setAttribute("class", "bg-white p-2 absolute z-10 border rounded shadow-md");
            const inputWidth = document.querySelector(`#${searchId}`).offsetWidth;
            source.style.width = `${inputWidth}px`;
            source.style.display = "none";
        },
        destination: document.querySelector(`#${searchId}`),
        position: "afterend",
        element: "ul"
    },
    maxResults: 5,
    highlight: true,
    resultItem: {
        content: (data, source) => {
            const wrap = document.createElement("div");
            wrap.setAttribute("class", "result-item cursor-pointer px-2 hover:bg-gray-100 rounded-md flex flex-col gap-1");

            const match = document.createElement("span");
            if (typeof data.value.birth_country !== 'undefined') {
                match.innerHTML = data.match + " (" + data.value.birth_country + ")";
            } else {
                match.innerHTML = data.match;
            }
            match.setAttribute("class", "font-bold text-sm pl-2 pt-1");

            wrap.appendChild(match);

            if (typeof data.value.sire !== 'undefined') {
                const siredam = document.createElement("span");
                siredam.innerHTML =
                    "<span class='text-gray-500'>Sire: </span>" +
                    data.value.sire +
                    " <span class='text-gray-500'>Dam: </span>" +
                    data.value.dam;
                siredam.setAttribute("class", "text-xxs pl-2");
                wrap.appendChild(siredam);
            }

            const divider = document.createElement("hr");
            divider.setAttribute("class", "border-gray-200");
            wrap.appendChild(divider);

            source.appendChild(wrap);
            source.style.display = "block";
        },
        element: "li"
    },
    noResults: () => {
        const dropdown = document.querySelector(`#dropdown-${searchId}`);
        if (dropdown) {
            dropdown.innerHTML = '';
            
            const result = document.createElement("li");
            result.setAttribute("class", "no-result px-2 py-1 text-gray-500");
            result.setAttribute("tabindex", "1");
            result.innerHTML = "No results found";
            
            dropdown.appendChild(result);
            dropdown.style.display = "block";
        }
    }
});